<template>
  <footer class="the-footer-sidebar text-xs my-2">
    <router-link :to="{name: 'uc_b_reference_information'}" tag="a" v-if="$acl.check('isEmployee')"
                 class="the-footer-sidebar__information">Справочная информация
    </router-link>
    <a class="block w-full text-center" href="https://myelsa.ru" target="_blank" rel="nofollow">ELSA (ООО "Невасофт"),
      ИНН 7814726620</a>
  </footer>
</template>

<script>
  export default {
    name: "TheSidebarFooter",
  }
</script>

<style lang="scss">
  .the-footer-sidebar {
    a {
      &:hover {
        text-decoration: underline;
      }
    }

    &__information {
      display: block;
      width: 100%;
      text-align: center;
      margin-bottom: .5rem;
      font-size: 1.125rem;
    }
  }
</style>
